import { render, staticRenderFns } from "./FiltroRecebimentoSindicato.vue?vue&type=template&id=653f02c4&scoped=true"
import script from "./FiltroRecebimentoSindicato.vue?vue&type=script&lang=js"
export * from "./FiltroRecebimentoSindicato.vue?vue&type=script&lang=js"
import style0 from "./FiltroRecebimentoSindicato.vue?vue&type=style&index=0&id=653f02c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653f02c4",
  null
  
)

export default component.exports